import { TripResult } from "@/types/trip.types";
import { Result } from "@/types/result.types";
import { Vehicle } from "@/types/vehicle.types";
import { FuelCategoryType } from "@/types/fuelCategory.types";
import { showPopup } from "@/components/warnings/Popup";

function getFuelUsedLOther(
  distance_km: number,
  vehicle: Vehicle,
  selectedNoCategoryValue: FuelCategoryType
) : number {

  if (selectedNoCategoryValue === "City") {
    return distance_km * vehicle.fuelConsumptionCity_L100km / 100;
  } else if (selectedNoCategoryValue === "City & Highway Combined") {
    return distance_km * vehicle.fuelConsumptionComb_L100km / 100;
  } else if (selectedNoCategoryValue === "Highway") {
    return distance_km * vehicle.fuelConsumptionHwy_L100km / 100;
  } else {
    showPopup("Invalid input for No Category fuel usage", "Input Error")
    return 0;
  }
}

function getResult(
  index: number,
  fuelCost: number,
  vehicle: Vehicle,
  tripResult: TripResult,
  selectedNoCategoryValue: FuelCategoryType
): Result {
  const fuelUsedLHwy = tripResult.wayCategory.summary["Highway"].distance_km * vehicle.fuelConsumptionHwy_L100km / 100
  const fuelUsedLOther = getFuelUsedLOther(
    tripResult.wayCategory.summary["No category"].distance_km,
    vehicle,
    selectedNoCategoryValue
  )

  const fuelUsedL = fuelUsedLHwy + fuelUsedLOther
  const co2_kg = vehicle.CO2Emissions_gKm * tripResult.distance_km / 1000

  return {
    id: index,
    make: vehicle.make,
    model: vehicle.model,
    modelYear: vehicle.modelYear,
    transmission: vehicle.transmission,
    vehicleClass: vehicle.vehicleClass,
    fuelType: vehicle.fuelType,
    cylinders: vehicle.cylinders,
    engineSize_L: vehicle.engineSize_L,
    co2_kg: co2_kg,
    fuelUsedL: fuelUsedL,
    fuelCost: fuelUsedL * fuelCost
  }
}

export function useResults(
  tripResult: TripResult | null,
  vehicles: Vehicle[],
  fuelCost: number,
  selectedNoCategoryValue: FuelCategoryType
): Result[]{
  if (!tripResult) return [];
  return vehicles.map((v, index) => (getResult(index, fuelCost, v, tripResult, selectedNoCategoryValue)));
};